import { Content, Page } from '@backstage/core-components';

import { AppHomeCard, DataProductsHomeCard, NewsHomeCard, ResponsibleHomeCard, SolutionsHomeCard, SupportCenterHomeCard } from './cards';
import { Header } from './Header';
import classes from './HomePage.module.css';

export const HomePage = () => (
  <Page themeId="home">
    <Content>
      <Header />
      <div className={classes.widgets}>
        <SolutionsHomeCard />
        <DataProductsHomeCard />
        <ResponsibleHomeCard />
        <AppHomeCard />
        <NewsHomeCard />
        <SupportCenterHomeCard />
      </div>
    </Content>
  </Page>
);
